/* eslint-disable no-unused-vars */
import React, { useState, createContext } from 'react';

export const Context = createContext({
  savingStatus: {},
  beginSaving: (savingInWatson = false) => {},
  finishSaving: () => {},
  setSavingStatus: () => {},
  resetSavingStatus: () => {},
});

export const ContextProviderSave = ({ children }) => {
  const [savingStatus, setSavingStatus] = useState({
    isSaving: false,
    lastSaveTime: null,
    isSuccessfulSave: true,
  });

  const beginSaving = (savingInWatson = false) => {
    setSavingStatus({
      ...savingStatus,
      isSaving: true,
      savingInWatson,
    });
  };

  const finishSaving = (savingInWatson = false) => {
    setSavingStatus({
      ...savingStatus,
      isSaving: false,
      savingInWatson,
      lastSaveTime: new Date(),
      isSuccessfulSave: true,
    });
  };

  const resetSavingStatus = () => {
    setSavingStatus({
      ...savingStatus,
      savingInWatson: false,
      lastSaveTime: null,
    });
  };

  return (
    <Context.Provider value={{
      savingStatus,
      setSavingStatus,
      beginSaving,
      finishSaving,
      resetSavingStatus,
    }}
    >
      {children}
    </Context.Provider>
  );
};

export default Context;
